<template>
    <div>
        <div ref="trigger">
        <slot>
            <ui-button  
                ref="btn"
                :disabled="disabled"
                icon="timer" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
            >Time</ui-button>
        </slot>
        </div>
        <ui-popover @open="$refs.teamPicker.reset()" ref="popover" :close-on-scroll="false" :close-on-external-click="false" :trigger="this.$refs.trigger" v-show="!disabled">
            <div style="width:100%; background:#f8f8f8; padding: .8rem 1rem;">Attach Time Card</div>
            <div style="padding: 1rem 1rem 0; width: 500px;">
                <div style="padding-bottom: .25rem">
                    <div class="row">
                        <div class="col">
                            <ui-datepicker :start-of-week="1" label="Date" v-model="card.card_date" :custom-formatter="dateFormatter"></ui-datepicker>
                        </div>
                        <div class="col">
                            <team-member-picker ref="teamPicker" :team-id="teamId" label="Team Member" v-model="userProxy"></team-member-picker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <ui-textbox 
                                placeholder="Notes (e.g. Changed oil & filter)" 
                                :rows="2" 
                                multi-line 
                                v-model="card.description" 
                                :enforce-max-length="true"
                                :max-length="256"
                            ></ui-textbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <ui-textbox label="Hours" v-model="hours"></ui-textbox>
                        </div>
                        <div class="col-3">
                            <ui-textbox label="Minutes" v-model="minutes"></ui-textbox>
                        </div>
                    </div>
                    <div class="row mb-2 mt-2">
                        <div class="col" style="display: flex; justify-content: flex-end;">
                            <ui-button @click="$refs.popover.close()" class="mr-2">Cancel</ui-button>
                            <ui-button :disabled="!canSubmit" @click="save" color="primary">Attach</ui-button>
                        </div>
                    </div>
                </div>
            </div>
        </ui-popover>
        </div>   
</template>

<script>
    import Moment from 'moment'
    import TeamMemberPicker from '../controls/KeenTeamMemberPicker'
    import { TimeCardSchema } from '../../../classes/Api/TimeCard'

    export default {
        components: {
            TeamMemberPicker,
        },
        props: {
            task: {
                type: Object,
                default: null,
            },
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
        },
        data() {
            return {
                card: new TimeCardSchema({
                    task_id: this.task.id,
                    user: window.marque.ui.user,
                    user_id: window.marque.ui.user.id
                }),
                minutes: null,
                hours: null
            }
        },
        watch: {
            hours(n, o) {
                if (n !== o) {
                    this.card.minutes = (parseInt(n) * 60);
                    if (this.minutes) {
                        this.card.minutes += parseInt(this.minutes);
                    }
                }
            },
            minutes(n, o) {
                if (n !== o) {
                    this.card.minutes = parseInt(n);
                    if (this.hours) {
                        this.card.minutes += (parseInt(this.hours) * 60)
                    }
                }
            }
        },
        methods: {
            dateFormatter(date) {
                return (new Moment(date)).format('DD/MM/YYYY');
            },
            save() {
                this.$emit('save', Object.assign({}, this.card));
                this.reset();
            },
            destroy() {
                this.$emit('save', null, null);
            },
            reset() {
                this.card = new TimeCardSchema({
                    task_id: this.task.id,
                    user: window.marque.ui.user,
                    user_id: window.marque.ui.user.id
                });

                this.minutes = this.hours = null

                this.$refs['popover'].close();
            },
            show() {
                this.$refs.popover.open()
            }
        },
        computed: {
            teamId() {
                if (this.task && this.task.team_id) {
                    return this.task.team_id
                }

                return null
            },
            canSubmit() {
                return this.card.user && this.card.minutes > 0
            },
            userProxy: {
                get() {
                    return this.card.user ? this.card.user : {}
                },
                set(value) {
                    this.card.user_id = value.id
                    this.card.user = value
                }
            }
        }
    }
</script>